import { makeStyles } from "@material-ui/core/styles";
import {
  calculateFontSize,
  setFontColorOnBg,
} from "../../CustomHooks/useThemeHook";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(5),
    // padding: theme.spacing(2.4, 0, 2, 0),
    // [theme.breakpoints.up('sm')]: {
    //     padding: theme.spacing(2.4, 0, 2, 0),
    // },
    // [theme.breakpoints.up('md')]: {
    //     padding: theme.spacing(2.4, 0, 2, 0),
    // },
  },
  title: {
    // ...theme.typography.rockwell,
    fontSize: calculateFontSize(24, theme.palette.common.fontVariation),
    fontWeight: 700,
    color: theme.palette.common.themeFontColor,
  },
  desc: {
    padding: theme.spacing(0.8, 0, 1.6, 0),
    fontSize: calculateFontSize(14, theme.palette.common.fontVariation),
    fontWeight: 400,
    lineHeight: "16px",
    color: theme.palette.common.themeFontColor,
  },
  nxtAvailableTime: {
    backgroundColor: "rgba(128, 128, 128, 0.8)", // Grey background with 80% opacity
    color: "#9C0A35", // Keep text color unaffected
    padding: theme.spacing(0.5, 1), // Add some padding
    borderRadius: theme.shape.borderRadius, // Slight rounding for a cleaner look
    display: "inline-block", // Ensures text behaves properly with background
  },
  nextAvailableDiv: {
    marginTop: theme.spacing(1), // Add spacing if needed
    textAlign: "center", // Center align the content
  },
  productListContainer: {
    position: "relative",
  },
  blurOverLay: {
    // filter: "blur(8px)",
    filter: "grayscale(100%)",
  },
  inActiveReasonTextContainer: {
    // position: "absolute",
    // width: "100%",
    // height: "100%",
    flexGrow: 1,
    display: "flex",
    alignItems: "center",
    marginLeft: theme.spacing(1.5),
  },
  inActiveReasonText: {
    // flexGrow: 1,
    textAlign: "center",
    fontSize: calculateFontSize(12, theme.palette.common.fontVariation),
    fontWeight: 600,
    color: theme.palette.common.red,

    // padding: theme.spacing(0.2, 0.8),
    // fontSize: theme.typography.pxToRem(12),
    // fontWeight: 600,
    // backgroundColor: theme.palette.common.red,
    // color: theme.palette.common.white,
    // borderRadius: 8,
  },
  titleContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  select: {
    height: "33px",
    fontSize: calculateFontSize(14, theme.palette.common.fontVariation),
    backgroundColor: "transparent",
    border: `1px solid ${theme.palette.common.normalTitle}`,
    color: theme.palette.common.normalTitle,
    "& .MuiSelect-icon": {
      color: theme.palette.common.normalTitle, // Change this to the color you want
    },
  },
  menuList: {
    color: theme.palette.common.normalTitle,
    "&.MuiListItem-root": {
      background: theme.palette.common.lighterBg, // Change this to the color you want
    },
    "&:hover": {
      backgroundColor: theme.palette.common.white,
    },
    "&.Mui-selected": {
      backgroundColor: theme.palette.common.white, // Change this to the color when selected
    },
    "&.Mui-selected:hover": {
      backgroundColor: theme.palette.common.black, // Change this to the color when selected and hovered
    },
  },
  subCatgeoryActiveBtn: {
    height: "33px",
    fontSize: calculateFontSize(14, theme.palette.common.fontVariation),
    backgroundColor: "whitesmoke",
    border: `1px solid ${theme.palette.common.black}`,
    color: theme.palette.common.black,
    marginRight: "10px",
    marginLeft: "10px",
  },
  subCatgeoryBtn: {
    height: "33px",
    fontSize: calculateFontSize(14, theme.palette.common.fontVariation),
    backgroundColor: theme?.palette?.button?.buttonColor || "transparent",
    border: theme?.palette?.button?.buttonBorder
      ? "1px solid black"
      : "1px solid black",
    color: setFontColorOnBg(
      theme?.palette?.button?.buttonColor || theme.palette.button.main
    ),
    borderRadius: theme?.palette?.button?.borderRadius || "12px",
    marginRight: "6px",
    marginLeft: "6px",
    "& .MuiButton-label": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    "&.MuiButton-contained": {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      boxShadow:
        "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px",
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  },
  buttonWrapper: {
    borderRadius: "5px", // Adjust the value as per your requirements
    display: "inline-block",
    overflow: "hidden",
    marginBottom: "10px",
  },
  radioDiv: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between",
    // flexWrap: 'wrap'
    overflow: "visible",
    marginBottom: theme.spacing(2),
    // marginTop: "10px",
    overflowX: "scroll",
    scrollbarWidth: "none",
    scrollbarColor: `#888 #f5f5f5`,
    "&::-webkit-scrollbar": {
      width: 0,
      height: 0 /* Width of the entire scrollbar */,
    },
    "&::-webkit-scrollbar-thumb": {
      background:
        theme.palette.common.scrollBarIdle /* Color of the scrollbar handle */,
      borderRadius: "4px" /* Rounded corners */,
    },
    "&::-webkit-scrollbar-track": {
      background:
        theme.palette.common.scrollBar /* Color of the scrollbar handle */,
      borderRadius: "4px" /* Rounded corners */,
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555" /* Color on hover */,
    },
  },
}));

export default useStyles;
